import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { FulfillmentPlanPropType } from '../../../../prop-types/fulfillment-plan';
import { OtherActions } from './other-actions';
import style from './shipment-details-modal-content.module.less';
import { useBTEmailExperienceNew } from '../../../../hooks/use-seller-setting';
import { emptyObject } from 'ui-components/default-props/empty';

export const OtherActionsButton = ({
  actions,
  shipmentStatus,
  trackingNumber = null,
  activeFulfillment,
  fulfillments,
  fulfillmentPlan = emptyObject,
  isShipmentFromCustomerDetails = false,
  markedComplete,
  orderGridStatus,
}) => {
  const enableNewEmailExperience = useBTEmailExperienceNew();
  const propsToPassDown = {
    actions,
    shipmentStatus,
    trackingNumber,
    activeFulfillment,
    fulfillments,
    fulfillmentPlan,
    isShipmentFromCustomerDetails,
    markedComplete,
    orderGridStatus,
    enableNewEmailExperience,
  };
  const filteredOtherActions = OtherActions.filter((action) => action.shouldBeShown(propsToPassDown));

  if (!filteredOtherActions.length) {
    return null;
  }

  return (
    <DropdownMenu dropdownMenuClassName={style['shipment-details-dropdown']} menuPosition='bottom-right'>
      <DropdownMenuToggler theme='white'>
        <FormattedMessage defaultMessage='Other Actions' description='shipmentDetailsOtherActions.otherActions' id='1cgr5n' />
      </DropdownMenuToggler>
      {filteredOtherActions.map((otherAction) => (
        <DropdownMenuItem key={otherAction.translation.id} onClick={() => otherAction.handler(propsToPassDown)}>
          <FormattedMessage {...otherAction.translation} />
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

OtherActionsButton.propTypes = {
  shipmentStatus: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  orderGridStatus: PropTypes.string.isRequired,
  markedComplete: PropTypes.bool.isRequired,
  trackingNumber: PropTypes.string,
  activeFulfillment: PropTypes.object,
  fulfillments: PropTypes.array.isRequired,
  fulfillmentPlan: FulfillmentPlanPropType,
  isShipmentFromCustomerDetails: PropTypes.bool,
};
